import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducers from './reducers';
import App from './App';
class Wrapper extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            store: createStore(reducers)
        }
    }

    render() {
        return (
            <Provider store={this.state.store}>
                <App refreshAdmin={this.props.refreshAdmin} />
            </Provider>
        )
    }
}

export default Wrapper;